<template>
    <v-container text-xs-center te mt-5 pt-5>
        <h1 class="mb-3">المستخدمين</h1>
        <v-list dense tile>
            <v-list-item v-for="(user, index) in users" :key="(user.id)">
                <template>
                    <v-list-item-content class="pa-0" @click="startEditing(index)">
                        {{user.name}}
                    </v-list-item-content>

                    <v-list-item-icon v-if="user.role !== 'admin'">
                        <v-btn color="success" small @click="makeAdminOrUser(user.id, 'admin')">تعيين ك مدير</v-btn>
                    </v-list-item-icon>

                    <v-list-item-icon v-else>
                        <v-btn color="secondary" class="black--text" small @click="makeAdminOrUser(user.id, 'user')">تعيين ك مستخدم</v-btn>
                    </v-list-item-icon>

                    <v-list-item-icon>
                        <v-btn color="secondary" class="black--text" small @click="dialog = true">حذف</v-btn>

                        <v-dialog v-model="dialog" max-width="290">
                            <v-card>
                                <v-card-title>تأكيد حذف المستخدم</v-card-title>

                                <v-card-text>
                                هل تريد حذف هذا المستخدم؟
                                </v-card-text>

                                <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-btn
                                    color="green darken-1"
                                    text
                                    @click="dialog = false"
                                >
                                    إلغاء
                                </v-btn>

                                <v-btn
                                    color="green darken-1"
                                    text
                                    @click="deleteUser(user.id)"
                                >
                                    حذف
                                </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-list-item-icon>
                </template>
            </v-list-item>

        </v-list>

        

    </v-container>
</template>

<script>
    import {
        GET_USERS, MAKE_ADMINORUSER, DELETE_USER
    } from '../graphql/Users'

    export default {
        data() {
            return {
                item: -1,
                users: '',
                dialog: false,
                inputs: [],
            }
        },
        apollo: {
            users: {
                query: GET_USERS
            }
        },
        methods: {
            deleteUser(id) {
                this.$apollo.mutate({
                    mutation: DELETE_USER,
                    variables: {
                        id: id
                    },
                    update: (cache, {data: { deleteUser }}) => {
                        //First read the query you want to update
                        const data = cache.readQuery({
                            query: GET_USERS
                        })

                        let index = data.users.findIndex(user => user.id === deleteUser.id) 

                        data.users.splice(index, 1)
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_USERS,
                            data
                        })
                    },

                }).then(({data}) => {
                    this.editOffset = -1
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            makeAdminOrUser(id, role) {
                this.$apollo.mutate({
                    mutation: MAKE_ADMINORUSER,
                    variables: {
                        id: id,
                        role: role,
                    }

                }).then(({data}) => {              
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            
        }
    }
</script>

<style scoped>
  .tile {
    margin: 5px;
    border-radius: 4px;
  }
  .tile:hover {
    background: green;
  }
  .tile:active {
    background: yellow;
  }
</style>